import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Register from './components/Register';
import Login from './components/Login';
import Layout from './components/shared/Layout';
import Home from './components/Home';
import ArticleManage from './components/ArticleManage';
import AdminDashboard from './components/admin/Dashboard';
import EvaluationDatabaseManage from './components/admin/EvaluationDatabaseManage';
import ArticleDetail from './components/ArticleDetail';
import CoachDashboard from './components/coach/Dashboard';
import StudentDashboard from './components/student/Dashboard';
import Schedule from './components/coach/Schedule';
import Booking from './components/student/Booking';
import UserList from './components/admin/UserList';
import BookingHistory from './components/student/BookingHistory';
import BookingManagement from './components/coach/BookingManagement';
import CoachScheduleCalendar from './components/public/CoachScheduleCalendar';
import ScheduleOfCoach from './components/public/ScheduleOfCoach';
import VerifyEmail from './components/VerifyEmail';
import EmailVerification from './components/EmailVerification';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StudentEvaluation from './components/coach/StudentEvaluation';
import CourseAssistant from './components/coach/CourseAssistant';
import ImageUploadTest from './components/ImageUploadTest';
import InstructorEvaluations from './components/admin/InstructorEvaluations';
import LegacyEvaluations from './components/admin/LegacyEvaluations';
import StudentEvaluationQuery from './components/public/StudentEvaluationQuery';

function App() {
  const PrivateRoute = ({ children, allowedRole }) => {
    const userStr = localStorage.getItem('user');
    const isAuthenticated = !!localStorage.getItem('token');
    
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }

    if (allowedRole) {
      const user = JSON.parse(userStr);
      if (user.role !== allowedRole) {
        return <Navigate to="/login" />;
      }
    }

    return <Layout>{children}</Layout>;
  };

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/test-upload" element={<ImageUploadTest />} />
            <Route path="/public/schedules" element={<CoachScheduleCalendar />} />
            <Route 
              path="/articles/manage" 
              element={
                <PrivateRoute>
                  <Routes>
                    <Route path="/" element={<ArticleManage />} />
                  </Routes>
                </PrivateRoute>
              }
            />
            <Route path="/public/scheduleOfCoach/:coachId" element={<ScheduleOfCoach />} />
            <Route path="/public/coach/:coachId/schedule/:month" element={<ScheduleOfCoach />} />  
            <Route path="/public/coach/:coachId/schedule"  element={<ScheduleOfCoach />} />          
            <Route 
              path="/student/*" 
              element={
                <PrivateRoute allowedRole="STUDENT">
                  <Routes>
                    <Route path="/" element={<StudentDashboard />} />
                    <Route path="booking" element={<Booking />} />
                    <Route path="history" element={<BookingHistory />} />
                  </Routes>
                </PrivateRoute>
              }
            />
            <Route 
              path="/coach/*" 
              element={
                <PrivateRoute allowedRole="COACH">
                  <Routes>
                    <Route path="/" element={<CoachDashboard />} />
                    <Route path="schedule" element={<Schedule />} />
                    <Route path="booking" element={<BookingManagement />} />
                    <Route path="evaluation" element={<StudentEvaluation />} />
                    <Route path="assistant" element={<CourseAssistant />} />
                  </Routes>
                </PrivateRoute>
              }
            />
            <Route 
              path="/admin/*" 
              element={
                <PrivateRoute allowedRole="ADMIN">
                  <Routes>
                    <Route path="/" element={<AdminDashboard />} />
                    <Route path="users" element={<UserList />} />
                    <Route path="evaluation-database" element={<EvaluationDatabaseManage />} />
                    <Route path="instructor-evaluations" element={<InstructorEvaluations />} />
                    <Route path="legacy-evaluations" element={<LegacyEvaluations />} />
                  </Routes>
                </PrivateRoute>
              }
            />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-email/:uidb64/:token" element={<EmailVerification />} />
            <Route path="/query-evaluation" element={<StudentEvaluationQuery />} />
          </Routes>
          <ToastContainer 
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
